import React from 'react';
import { SITE_ROUTER, TRACKER, URL_PARAMETER } from '~/constants';
import { compact, filter, getQueryRouter, isEmpty, tracker } from '~/utils';
import Intl from '@fx-ui/intl';
import { IconFont } from '~/components';
import { Hyperlink } from '@fx-ui/jdy-design-biz';
import { UserPanel, getCorpAdminUrl } from '@fx-ui/platform-sdk';
import { useStores } from '~/hooks';

interface IProfileProps {
    size?: 'large' | 'small' | number;
    items?: ProfileMenuType[];
}

// 导航栏个人头像下拉菜单项（不包括【退出】）
export enum ProfileMenuType {
    // 我的收藏
    favorite = 'favorite',
    // 个人设置
    setting = 'setting',
    // 管理后台
    corp_management = 'corp_management',
    // 登录日志
    log = 'log',
    // 版本购买
    vip_purchase = 'vip_purchase'
}

const Profile = (props: IProfileProps) => {
    const { size = 24, items } = props;

    const { corpUserStore } = useStores();

    const handleMenuItemClick = (type: string, value?: any) => {
        tracker(TRACKER.HEAD_MENU_BUTTON_CLICK, { area: '', type: type, value });
    };

    /**
     * 个人中心面板内容
     */
    const getProfileItems = () => {
        const currentPageRefererParam = {
            key: URL_PARAMETER.REFERER_URI,
            value: encodeURIComponent(window.location.href)
        };
        const personalLink = getQueryRouter([currentPageRefererParam], SITE_ROUTER.ACCOUNT.INDEX);

        const handleMenuItemClick = (type: string) => {
            tracker(TRACKER.HEAD_MENU_BUTTON_CLICK, { area: '', type: type });
        };

        const contentClass = 'fx-nav-item';

        const menuItems = compact([
            {
                key: ProfileMenuType.setting,
                content: (
                    <Hyperlink
                        compact
                        underline={false}
                        target="_self"
                        className={contentClass}
                        href={personalLink}
                        onClick={() => {
                            handleMenuItemClick('setting');
                        }}
                    >
                        <IconFont type="gear" />
                        <span>{Intl.get('personal.set')}</span>
                    </Hyperlink>
                )
            },
            corpUserStore.isCurrentCorpExist &&
                corpUserStore.hasPlatformManager && {
                    key: ProfileMenuType.corp_management,
                    content: (
                        <Hyperlink
                            compact
                            underline={false}
                            target="_self"
                            className={contentClass}
                            href={getCorpAdminUrl()}
                            onClick={() => {
                                handleMenuItemClick('corp_management');
                            }}
                        >
                            <IconFont type="interface-gear" />
                            <span>{Intl.get('manage.background')}</span>
                        </Hyperlink>
                    )
                }
        ]);

        if (!isEmpty(items)) {
            const itemSet = new Set(items);
            return filter(menuItems, (item) => itemSet.has(item.key));
        }
        return menuItems;
    };

    return (
        <>
            <UserPanel
                showIcon
                avatarSize={size}
                onTriggerClick={() => {
                    tracker(TRACKER.NAV_TOOLBAR_CLICK, {
                        area: '',
                        type: 'head'
                    });
                }}
                items={getProfileItems()}
                onMenuClick={handleMenuItemClick}
            />
        </>
    );
};

export default Profile;
